export default "__VITE_ASSET__BEH3SyAP__"